"use strict";

var _regeneratorRuntime = require("/go/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataProvider = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactApollo = require("react-apollo");

var _reactApolloHooks = require("react-apollo-hooks");

var _apolloLinkHttp = require("apollo-link-http");

var _apolloLink = require("apollo-link");

var _apolloLinkContext = require("apollo-link-context");

var _awsAppsync = _interopRequireWildcard(require("aws-appsync"));

var _v = _interopRequireDefault(require("uuid/v4"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var appSyncClient = function appSyncClient(_ref) {
  var url = _ref.url,
      _ref$region = _ref.region,
      region = _ref$region === void 0 ? "ap-southeast-2" : _ref$region,
      _ref$auth = _ref.auth,
      auth = _ref$auth === void 0 ? {
    type: "OPENID_CONNECT",
    jwtToken: function () {
      var _jwtToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", localStorage.getItem("id_token"));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function jwtToken() {
        return _jwtToken.apply(this, arguments);
      }

      return jwtToken;
    }()
  } : _ref$auth;
  return new _awsAppsync["default"]({
    url: url,
    region: region,
    auth: auth
  }, {
    link: (0, _awsAppsync.createAppSyncLink)(_objectSpread(_objectSpread({}, {
      url: url,
      region: region,
      auth: auth
    }), {}, {
      resultsFetcherLink: _apolloLink.ApolloLink.from([(0, _apolloLinkContext.setContext)(function (_, previousContext) {
        return {
          headers: _objectSpread(_objectSpread({}, previousContext.headers), {}, {
            "X-Request-ID": (0, _v["default"])()
          })
        };
      }), (0, _apolloLinkHttp.createHttpLink)({
        uri: url
      })])
    }))
  });
};

var DataContext = /*#__PURE__*/_react["default"].createContext({});

var DataProvider = function DataProvider(_ref2) {
  var children = _ref2.children,
      url = _ref2.url;
  var client = appSyncClient({
    url: url
  });
  return /*#__PURE__*/_react["default"].createElement(DataContext.Provider, {
    value: {
      client: client
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactApollo.ApolloProvider, {
    client: client
  }, /*#__PURE__*/_react["default"].createElement(_reactApolloHooks.ApolloProvider, {
    client: client
  }, children)));
};

exports.DataProvider = DataProvider;
DataProvider.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired
};
var _default = DataContext;
exports["default"] = _default;